export const spaceId = "ndui8g7jkwux"
export const accessToken = "ZLQ6fDaUUqxyTpn7OqT57IH_l3-3r3EV418c9riz_EM"
